import { OnInit, Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SubcategoryService } from '../services/subcategory.service';
import { CategoryService} from '../services/category.service';
import { catchError } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { AlertService } from '../services/alert.service';
import { StorageService } from '../services/storage.service';
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router"
import { of } from 'rxjs'
import { SpinnerService } from './../services/spinner.service';
import { MsalService } from '@azure/msal-angular';
import { UploadService } from '../services/upload.service';

@Component({

  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: ['./subcategory.component.css']
})
export class SubcategoryComponent implements OnInit {

  items: any;
  categories: any;
  productcategoryid: number;
  @ViewChild('addSubcategory') elSubcategory: ElementRef;
  private route: ActivatedRoute;
  id:number;
  CreationDate:any;
  ProductSubCategory1:any;
  CreatedBy:any;
  ProductSubCategoryImageName:any;
  AddShowHide:boolean = true;
  EditShowHide:boolean = true;
  CreateShowHide:boolean = false;
  UpdateShowHide:boolean = false;
  CancelShowHide = false;
  reverse: boolean = false;
  public username;
  baseUrl = environment.baseUrl;
  filename: any;
  isShown:boolean = true;
  imagesource: any;
  productsubcategoryimagename: any;

  frmSubCategory = new FormGroup({
    ProductCategoryId: new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductSubCategory: new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductSubCategoryTitle : new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductSubCategoryDescription  : new FormControl('', [Validators.required, Validators.minLength(1)]),
    SubCategoryImage  : new FormControl('', [Validators.required]),
    ProductSubCategoryImageName  : new FormControl(''),
    OrderBy : new FormControl('', [Validators.required, Validators.minLength(1)]),

  });

  config = {
    id: 'SubCategory',
    itemsPerPage: environment.pagination.pagesize,
    currentPage: 0,
    totalItems: 0,
  };

  param = environment.pagination;
  // {
  //   SortColumnName :"Modifiedby",
  //   SortOrder :"DESC",
  //   PageSelected:0,
  //   PageSize:2
  // };

  constructor(private renderer: Renderer2,
              private _subcategoryservice: SubcategoryService,
              private _categoryservice: CategoryService,
              private _alertService: AlertService,
              private router: Router,
              public storage: StorageService,
              private spinner: SpinnerService,private authService: MsalService,
              private _uploadservice: UploadService) {
                // const tokenitems = { ...localStorage };
                // if(tokenitems.TokenInfo != undefined) {
                //     var clienttoken = jwt_decode(JSON.parse(tokenitems.TokenInfo).access_token);
                //     var isAdmin;
                //     var groups;
                //     //console.log('clienttoken');
                //     //console.log(clienttoken);
                //     this.username = clienttoken["unique_name"];
                //     groups = clienttoken["groups"].split(',');

                //     isAdmin = groups.indexOf("GPI-Aces-Admins",0) != -1;
                //     if(!isAdmin){
                //         this.router.navigate(['/accessdenied']);
                //     }
                // }

  }
  ngOnInit() {
    this.spinner.showSpinner();
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount) {
      this.username = activeAccount.username;
    }
    //console.log(this.param);
    this.GetCategories();
    this.GetSubCategories();
    this.spinner.hideSpinner();
  }
  SortOder(sortBy){
    if (this.param.SortOrder === "ASC") {
      this.reverse = !this.reverse;
      this.param.SortOrder = "DESC"
    } else{
      this.param.SortOrder = "ASC"
    }
    this.param.SortColumnName = sortBy;
    this.GetSubCategories();
  }

  Cancel(){
    this.spinner.showSpinner();
    this.id = 0;
    this.frmSubCategory.setValue({ProductCategoryId:"",
                               ProductSubCategory:"",
                               ProductSubCategoryDescription:"",
                               ProductSubCategoryTitle:"",
                               SubCategoryImage:"",
                               ProductSubCategoryImageName: "",
                               OrderBy:""
                              });
    this.AddShowHide = true;
    this.EditShowHide = true;
    this.CreateShowHide = false;
    this.UpdateShowHide =false;
    this.CancelShowHide = false;
    this.spinner.hideSpinner();
  }

  GetSubCategories() {
    this._subcategoryservice.getSubCategoryList(this.param).subscribe((data: any) => {
      //console.log('data');
      //console.log(data);
      var stringified = JSON.stringify(data);
      this.items = JSON.parse(stringified).PagedDataModel;
      this.config.totalItems = JSON.parse(stringified).page.TotalCount;

   });
  }

  GetCategory(categoryId){
    return this.categories.find(x => x.id == categoryId).productCategory1;
  }

  GetCategories() {
    this._categoryservice.getProductCategories().subscribe((data: any) => {
      //console.log('categories');
      //console.log(data);
      var stringifiedcategories = JSON.stringify(data);
      this.categories = JSON.parse(stringifiedcategories);

   });
  }
  pageChanged(event){
    this.config.currentPage = event;
    this.param.PageSelected = event;
    this.GetSubCategories();
  }
  printproductCategoryId(){
    //console.log(this.frmSubCategory.controls);
  }
  EditSubCategory(item){
    this.spinner.showSpinner();
    //console.log(item);
    this.id = item.Id;
    this.CreationDate = item.CreationDate;
    this.ProductSubCategory1 = item.ProductSubCategory1;
    this.CreatedBy = item.CreatedBy;
    this.productsubcategoryimagename = item.ProductSubCategoryImageName;
    this.frmSubCategory.setValue({
      ProductCategoryId:item.ProductCategoryId,
      ProductSubCategory:item.ProductSubCategory1,
      ProductSubCategoryDescription:item.ProductSubCategoryDescription,
      ProductSubCategoryTitle:item.ProductSubCategoryTitle,
      ProductSubCategoryImageName: item.ProductSubCategoryImageName,
      SubCategoryImage: item.ProductSubCategoryImageName,
      OrderBy: item.OrderBy
    });

    this.EditShowHide = false;
    this.AddShowHide = false;
    this.CreateShowHide = false;
    this.UpdateShowHide =true;
    this.CancelShowHide = true;

    //console.log(this.EditShowHide);
    //console.log(this.AddShowHide);
    //console.log(this.UpdateShowHide);

    this.spinner.hideSpinner();
  }
  AddSubCategory(){
    this.spinner.showSpinner();
    this.id = 0;
    this.AddShowHide = false;
    this.EditShowHide = false;
    this.CreateShowHide = true;
    this.UpdateShowHide =false;
    this.CancelShowHide = true;
    this.spinner.hideSpinner();
  }
  Validation(frmSc:FormGroup){
    let invalidfield : String = '';

  if (frmSc.invalid) {
      Object.keys(frmSc.controls).forEach((key) => {
          if(frmSc.get(key).invalid == true){
              // Add validation
              // if(invalidfield == ''){
              //     invalidfield = "Please enter " +  key.charAt(0).toUpperCase() + key.substr(1).toLowerCase()+ "<br/>";
              // } else {
              //     invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
              // }
          }
      });
      this._alertService.showError(invalidfield);
    }
  }
  CreateSubCategory(files) {
    this.spinner.showSpinner();
    if (this.frmSubCategory.invalid) {
      this.Validation(this.frmSubCategory);
      this.spinner.hideSpinner();
      return;
    }

    if(files[0] != null){
      this.save(files);
    }

    let SubCategoryModel = {
      id :this.id,
      ProductSubCategory1: this.frmSubCategory.get('ProductSubCategory').value,
      ProductCategoryId: this.frmSubCategory.get('ProductCategoryId').value,
      productSubCategory: this.frmSubCategory.get('ProductSubCategory').value,
      productSubCategoryDescription: this.frmSubCategory.get('ProductSubCategoryDescription').value,
      productSubCategoryTitle: this.frmSubCategory.get('ProductSubCategoryTitle').value,
      CreatedBy: this.username,
      CreationDate: new Date(),
      LastModifiedBy: this.username,
      LastModificationDate: new Date(),
      ProductSubCategoryImageName: this.frmSubCategory.get('ProductSubCategoryImageName').value,
      OrderBy: this.frmSubCategory.get('OrderBy').value

    }

    let retvalue = this._subcategoryservice.postSubCategory(SubCategoryModel);
    retvalue.pipe(
      catchError(err => {
        this._alertService.showError("Error while creating record");
        return of(null);
      })).subscribe((value: any) => {
        this.param.SortOrder = "DESC";
      this.GetSubCategories();
      this.Cancel();
      this._alertService.showSuccess("Record created successfully");
      })
      this.spinner.hideSpinner();
    }

    UpdateSubCategory(files) {
      this.spinner.showSpinner();
      if (this.frmSubCategory.invalid) {
        this.Validation(this.frmSubCategory);
        this.spinner.hideSpinner();
        return;
      }

      if(files[0] != null){
        this.save(files);
      }

      let SubCategoryModel = {
        id: this.id,
        CreationDate:this.CreationDate,
        CreatedBy:this.CreatedBy,
        ProductSubCategory1:this.frmSubCategory.get('ProductSubCategory').value,
        ProductCategoryId: this.frmSubCategory.get('ProductCategoryId').value,
        productSubCategory: this.frmSubCategory.get('ProductSubCategory').value,
        productSubCategoryDescription: this.frmSubCategory.get('ProductSubCategoryDescription').value,
        productSubCategoryTitle: this.frmSubCategory.get('ProductSubCategoryTitle').value,
        LastModifiedBy: this.username,
        LastModificationDate: new Date(),
        ProductSubCategoryImageName: this.frmSubCategory.get('ProductSubCategoryImageName').value,
        OrderBy: this.frmSubCategory.get('OrderBy').value
      }

      let retvalue = this._subcategoryservice.putSubCategory(SubCategoryModel);
      retvalue.pipe(
        catchError(err => {
          alert("Error while creating record!!!");
          return of(null);
        })).subscribe((value: any) => {
          this.param.SortOrder = "DESC";
          this.GetSubCategories();
          this.Cancel();
          setTimeout("",1000);
          this._alertService.showSuccess("Record updated successfully");
        })

        this.spinner.hideSpinner();
  }

  //delete Sub Category
  DeleteSubCategory(subCategoryId: number) {
    if (confirm('Are you sure to delete this record ?')) {
      this._subcategoryservice.deleteSubCategory(subCategoryId).subscribe(
        (data: any) => {
          this._alertService.showSuccess("Deleted successfully");
        },
        err => {
          if (err.status == 400)
            this._alertService.showError("No data exists");
          else
            this._alertService.showError("Bad request");
        }
      );
      this.GetSubCategories();
    }
  }

  setFilename(files) {
    if (files[0]) {
      this.filename = files[0].name;
      this.isShown = false;
    }
  }
  
  save(files) {
    var start = Date.now().toString();
    var timestampSuffix = start.substr(start.length - 4);
    
    if(this.filename===undefined)
      return;
    const formdata = new FormData();
    var filename ='';
    
    
    filename = this.frmSubCategory.value.ProductSubCategory + timestampSuffix+  '.jpg';
    if (files[0]) {
      //console.log(files[0].name);
    
      formdata.append(filename, files[0]);
      //console.log("append" )
    }
    //console.log(filename);
    this.frmSubCategory.patchValue({ProductSubCategoryImageName: filename});
    //console.log(formdata);
    //console.log(this.frmProduct.value.ProductName);
  
    this._uploadservice
      .upload(formdata)
      .subscribe(({ path }) => (this.imagesource = path));
    formdata.delete(filename);    
    } 

  }

